<template>
  <div class="userMenu">

    <template v-if="showUser">
      <UserInfo></UserInfo>
      <router-link
          :to="{name: 'OrdersView'}"
          class="userMenu__line"
          @click="$emit('closeMenu')"
      >
        <div class="userMenu__item">
          Заказы
        </div>
        <div class="userMenu__counter">
            {{settings.orderCount}}
        </div>
      </router-link>
      <router-link
          :to="{name: 'ContactsView'}"
          class="userMenu__line"
          @click="$emit('closeMenu')"
      >
        <div class="userMenu__item">
          Контакты
        </div>
      </router-link>

    </template>
    <div v-else class="userMenu__line">
      <div class="userMenu__item">
        <MainIcon name="phone"></MainIcon>
        Контакты
      </div>
    </div>

    <div class="userMenu__footer">
      <hr>
      <div class="userMenu__footerLine">
        <ConsentLink class="userMenu__link" slug="consent-confidential">Политика конфиденциальности</ConsentLink>
      </div>
      <div class="userMenu__footerLine">
        <ConsentLink class="userMenu__link" slug="consent-personal">Согласие на обработку персональных данных</ConsentLink>
      </div>
    </div>
    <template v-if="!showUser">
      <ActionButton @click="signInHandler">
        <template #caption>Войти</template>
      </ActionButton>
      <ActionButton @click="singUpHandler">
        <template #caption>Зарегистрироваться</template>
      </ActionButton>
    </template>
    <template v-else>
      <ActionButton @click="logoutHandler">
        <template #caption>Выйти из аккаунта</template>
      </ActionButton>
    </template>
  </div>
</template>

<script>
import MainIcon from "@/components/ui/MainIcon.vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import ConsentLink from "@/components/ui/ConsentLink.vue";
import UserInfo from "@/components/UserMenu/UserInfo.vue";
import {useRouter} from "vue-router";
import {useAuthStore} from "@/store/auth";
import {computed} from "vue";
import {useSettingsStore} from "@/store/settings";

export default {
  name: "UserMenu",
  components: {UserInfo, ActionButton, MainIcon, ConsentLink},
  props: ['userData'],
  emits: ['closeMenu'],
  setup(props, { emit }) {
    const authStore = useAuthStore();
    const settings = useSettingsStore()
    const router = useRouter();
    const showUser = computed(() => {
      return authStore.userId;
    })
    function singUpHandler() {
      router.push({name: 'SignUpStep1View'});
      emit('closeMenu');
    }

    function signInHandler() {
      emit('closeMenu');
      router.push({name: 'SignInView'});
    }
    function logoutHandler() {
      emit('closeMenu');
      authStore.doLogout();
      router.push({ name: "HomePage" });
    }

    return {
      logoutHandler,
      showUser,
      signInHandler,
      singUpHandler,
      settings
    }
  }
}
</script>


<style scoped lang="scss">
.userMenu {
  font-family: var(--cd-default-font);
  width: 362px;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0px 4px 8px 0px #1C1C1D47;
  background: var(--cd-card-bg);
  display: flex;
  flex-direction: column;
  gap: 16px;

  hr {
    border: 1px solid var(--cd-spoiler-border-color);
    margin: 8px 0;
  }

  &__footer {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__footerLine {
    text-align: left;
    color: var(--cd-text-minor);
    font-size: 14px;
    font-weight: 400;
  }

  &__line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--cd-text-muted);
  }
  &__item {
    display: flex;
    font-size: 16px;
    text-transform: uppercase;
    padding: 8px 0;
    align-items: center;
    gap: 8px;
  }
  &__counter {
    min-width: 24px;
    height: 24px;
    border-radius: 1000px;
    padding: 0 6px;
    background: var(--cd-button-bg-color);
    color: var(--cd-text-muted);
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__link {
    text-decoration: none;
    color: var(--cd-text-minor);
  }
}

</style>
